import { Dispatch } from '../../types';
import { profileNeedsReLoad } from '../../lifecycle/auth';
import { IframeLoadingState } from '@mulesoft/monitoring-center-components'
import { actions as lifecycleActions } from '../../lifecycle/lifecycle';

/**
 *  Action Constants
 */
export const ChangeIframeState = 'Monitoring/Iframe/ChangeIframeState';
export const NotifyEvent = 'Monitoring/Iframe/NotifyEvent';

/**
 *  Action Type
 */

export type ChangeIframeState = {
  type: 'Monitoring/Iframe/ChangeIframeState',
  payload: {
    state: IframeLoadingState,
    src: string
  }
}
export type NotifyEvent = {
  type: 'Monitoring/Iframe/NotifyEvent',
  payload?: {
    type: string,
    event: string,
    detail?: any
  }
}

/**
 *  Action Creators
 */
export const changeIframeState = (state: IframeLoadingState, src: string): ChangeIframeState => ({
  type: ChangeIframeState,
  payload: {state, src}
});

export const notifyEvent = (type: string, event: string, detail?: any): NotifyEvent => ({
  type: NotifyEvent,
  payload: {type, event, detail}
});

export const notifyIframeError = (error: any) => (dispatch: Dispatch) => {
  if ([401, 403].indexOf(error.errorCode) >= 0) {
    dispatch(profileNeedsReLoad())
  } else {
    dispatch(lifecycleActions.unexpectedError(error))
  }
};

export type IframeActions =
  | ChangeIframeState
  | NotifyEvent
